import { Component, inject, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Subject, debounceTime } from 'rxjs';
import { VesseService } from 'src/app/shared/service/disbursment/vessel.service';
import { MaVessel } from '../../../dis-repository/pages/create-client/vessel.model';
import { CreateVesselComponent } from '../../../dis-repository/pages/create-vessel/create-vessel.component';
import { DisbursmentService } from 'src/app/shared/service/disbursment/disbursment.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-vessel',
  templateUrl: './vessel.component.html',
  styleUrls: ['./vessel.component.scss'],
})
export class VesselComponent {
  displayedColumns: string[] = [
    'Sl.No',
    'name',
    'grt',
    'rgrt',
    'nrt',
    'loa',
    'beam',
    'depth',
    'type',
    'imo_number',
    'dwt',
    'email',
    'Action',
  ];

  currentPage = 1;
  pageSize = 50;
  totalCount = 0;
  allDataLoaded = false;
  private searchSubject = new Subject<string>();

  constructor(
    private dialog: MatDialog,
    private vesselService: VesseService,
    private requestFormService: RequestFormService,
  ) {}

  dataSource = new MatTableDataSource<MaVessel>();
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  private loader = inject(DisbursmentService);
  isLoading$ = this.loader.loading$;
  searchTerm: string = '';

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.getVesselDataFromDb();

    // Setup debounce for search
    this.searchSubject.pipe(debounceTime(1000)).subscribe(() => {
      this.onSearch();
    });
  }

  ngOnDestroy() {
    this.searchSubject.complete();
  }

  onSearch(): void {
    this.getVesselDataFromDb(true);
  }

  clearSearch(): void {
    this.searchTerm = '';
    this.getVesselDataFromDb(true);
  }

  // Method to open dialog in create mode
  openAddVesselDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    const dialogRef = this.dialog.open(CreateVesselComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getVesselDataFromDb();
      }
    });
  }

  // Method to open dialog in edit mode
  openEditVesselDialog(rowData: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.position = { right: '0' };
    dialogConfig.height = '100%';
    dialogConfig.panelClass = ['animate__animated', 'animate__slideInRight'];
    dialogConfig.data = { rowData };
    const dialogRef = this.dialog.open(CreateVesselComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'refresh') {
        this.getVesselDataFromDb();
      }
    });
  }

  getVesselDataFromDb(reset = false) {
    if (reset) {
      this.currentPage = 1;
      this.allDataLoaded = false;
      this.dataSource.data = [];
      this.totalCount = 0;
    }

    const body = {
      page: this.currentPage,
      page_size: this.pageSize,
      query: this.searchTerm.trim(),
    };

    this.loader.show();

    this.vesselService.VesselDataFromDb(body).subscribe({
      next: (response: { total_count: number; data: MaVessel[] }) => {
        const newData = response.data;
        this.totalCount = response.total_count;
        this.dataSource.data = [...this.dataSource.data, ...newData];

        if (this.dataSource.data.length >= this.totalCount) {
          this.allDataLoaded = true;
        }

        this.currentPage++; // Increment the page number for next request
        this.loader.hide();
      },
      error: (err: any) => {
        console.error('Error fetching data:', err);
        this.loader.hide();
      },
    });
  }

  inputSearch(): void {
    if (this.searchTerm.trim() === '') {
      this.onSearch();
    } else {
      this.searchSubject.next(this.searchTerm);
    }
  }

  onManualScroll(): void {
    const scrollContainer = document.querySelector('.table-container');
    if (scrollContainer) {
      const scrollPosition =
        scrollContainer.scrollTop + scrollContainer.clientHeight;
      const scrollHeight = scrollContainer.scrollHeight;
      if (
        scrollPosition >= scrollHeight - 10 &&
        !this.loader.loading$ &&
        !this.allDataLoaded
      ) {
        this.getVesselDataFromDb();
      }
    }
  }
       isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
